export default __webpack_public_path__ + "static/Tek_Hatchframe-b38dab333b3425454dc0f014c03704ec.png";